import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EditeurComponent } from './components/editeur.component';
import { CreerObjetMaquetteComponent } from '@app/features/editeur/components/sidebar/creer-objet-maquette/creer-objet-maquette.component';
import { autorisationGuard } from '@app/shared/autorisations/autorisations.guard';
import { Traitement } from '@app/shared/autorisations/traitements';

const routes: Routes = [
    { path: '', component: EditeurComponent },
    {
        path: 'creer/:espaceId',
        component: CreerObjetMaquetteComponent,
        canActivate: [autorisationGuard(Traitement.ODF_CREER_OBJET_MAQUETTE)]
    },
    { path: ':id', component: EditeurComponent, canActivate: [autorisationGuard(Traitement.ODF_LIRE_OBJET_MAQUETTE)] },
    { path: 'espace/:espaceId', component: EditeurComponent, canActivate: [autorisationGuard(Traitement.ODF_LIRE_OBJET_MAQUETTE)] }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class EditeurRoutingModule {}
